/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "button_add": [{
    "type": 0,
    "value": "Add"
  }],
  "button_remove_all": [{
    "type": 0,
    "value": "Remove all"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var enUS = Object.assign(TranslationProviderComponent, {
  translations
});

export { enUS as e };
//# sourceMappingURL=en-US-DsQA0Y_c.js.map
